<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    max-height="80%"
    :style="{ zIndex: 200 }"
    @keydown.esc="cancel"
    @click:outside="cancel"
  >
    <v-card>
      <v-app-bar
        absolute
        color="primary"
        scroll-target="#scrolling-TranslationPresetViewer"
        id="header-TranslationPresetViewer"
        class="translationPresetViewer__header"
      >
        <v-toolbar-title class="white--text">
          <template v-if="parameters !== null">
            {{ name }}&nbsp;({{ id }})
          </template>
          <template v-else>
            {{ $t("message.common.no_id", { id: id }) }}
          </template>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon color="white" v-on="on" class="ma-2" @click.native="cancel">
                mdi-close
              </v-icon>
            </template>
            <span>{{ $t("message.common.close") }}</span>
          </v-tooltip>
        </v-toolbar-items>
      </v-app-bar>
      <v-sheet
        id="scrolling-TranslationPresetViewer"
        class="overflow-y-auto"
        :max-height="sheetHeight"
      >
        <template v-if="parameters">
          <JobParameters
            class="pa-5"
            :mode="mode"
            type="translate"
            :parameters="parameters"
            :expand="true"
            :nav_path="nav_path"
          >
          </JobParameters>
        </template>
      </v-sheet>
    </v-card>
  </v-dialog>
</template>

<script>
import JobParameters from '../components/JobParameters';
import { http_error } from "../js/http_error";
import { get_eid } from "../js/get_eid";

export default {
  name: 'translation_preset_viewer',
  components: {
    JobParameters
  },
  mixins: [
    http_error, get_eid
  ],
  props: {
    mode: String,
    nav_path: String
  },
  data: function(){
    return {
      module_id: "84",
      dialog: false,
      parameters: null,
      name: "",
      id: "",
      window: window,
      sheetHeight: 0,
    };
  },
  methods: {
    open(name, type, id) {
      this.name = name;
      this.id = id;
      this.dialog = true;
      this.$http.get(this.$store.getters.api_endpoint + "/" + this.get_prefix() + type + "/" + id + "/json")
        .then( response => {
          if(this.$store.getters.debug){
            console.log("response.data:" + JSON.stringify(response.data));
          }
          if("format" in response.data
            && "type" in response.data.format
            && response.data.format.type === "translation_preset"
            && "contents" in response.data){
            this.parameters = response.data.contents;
          }
          this.createSheetHeight();
        })
        .catch(error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    cancel() {
      this.dialog = false;
      this.name = "";
      this.id = "";
      this.parameters = null;
      window.removeEventListener('resize', this.createSheetHeight);
    },
    get_prefix: function(){
      if(this.mode === "user"){
        return "";
      }else{
        return this.mode + "/";
      }
    },
    // sheet内の高さを設定
    createSheetHeight() {
      const $header = document.getElementById('header-TranslationPresetViewer');
      const headerHeight = $header.clientHeight;
      this.sheetHeight = window.innerHeight * 0.8 - headerHeight;
      window.addEventListener('resize', this.createSheetHeight);
    },
  },
  computed: {
  }
}
</script>
<style>
div.v-toolbar__extension {
  display: block;
  background-color: #FFF;
  padding: 0;
  padding-top: 8px;
}
.translationPresetViewer__header {
  position: relative !important;
}
</style>
